import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// Pages
import Home from './pages/home.js';
import Team from './pages/team.js';
import AboutUs from './pages/team-about-us.js';
import ContactUs from './pages/contact-us.js';
import JoinUs from './pages/join-us.js';
import AcceptableUse from './pages/acceptable-use.js';
import AmazonShop2 from './pages/amazon-shop-2.js';
import OurTechnology from './pages/our-technology.js';
import OurTechnologySmartMeters from './pages/our-technology-smart-meters.js';
import OurTechnologyContinuousLearning from './pages/our-technology-continuous-learning.js';
import IntegrateWithVoltaware from './pages/integrate-with-voltaware.js';
import Blog from './pages/blog.js';
import BlogPost from './pages/blog-post.js';
import { BlogPosts } from './pages/blog/blog-posts.js';
import Support from './pages/support.js';
import PrivacyPolicy from './pages/privacy-policy.js';
import ProductTerms from './pages/product-terms.js';
import ConsumerStandardTerms from './pages/consumer-standard-terms.js';
import Cancellation from './pages/cancellation.js';
import LandingCaseStudy from './pages/case-studies/cut-energy-bill-uk-case-study.js';
// import LandingDeal from './pages/landing-deal.js';
import Layout from './components/layout.js';

import { ROUTES_PATHS } from './v2/constants.js';
import { V2AmazonShop } from './v2/pages/amazon-shop';
import { V2APIsAndIntegrations } from './v2/pages/our-technology/apis-and-integrations/apis-and-integrations.jsx';
import { V2EnergyIntelligence } from './v2/pages/our-technology/energy-intelligence/energy-intelligence.jsx';
import { V2Hardware } from './v2/pages/our-technology/hardware/hardware.jsx';
import { V2Home } from './v2/pages/home';
import { V2Layout } from './v2/ui/layouts/layout.jsx';
import { V2RequestADemo } from './v2/pages/request-a-demo/request-a-demo.jsx';
import { V2Utilities } from './v2/pages/utilities/utilities.jsx';
// import { V2Voltabot } from './v2/pages/voltabot';

const routes = (
  <Switch>
    <Route
      render={() => (
        <Layout>
          <V2Layout>
            <Switch>
              <Route
                path={[
                  ROUTES_PATHS.HOME,
                  ROUTES_PATHS.AMAZON_SHOP,
                  ROUTES_PATHS.APIS_AND_INTEGRATIONS,
                  ROUTES_PATHS.ENERGY_INTELLIGENCE,
                  ROUTES_PATHS.HARDWARE,
                  ROUTES_PATHS.OFFER_TO_UTILITIES,
                  ROUTES_PATHS.REQUEST_A_DEMO,
                  // ROUTES_PATHS.VOLTABOT,
                ]}
                exact
                render={() => (
                  <Switch>
                    <Route exact path={ROUTES_PATHS.HOME} component={V2Home} />
                    <Route
                      exact
                      path={ROUTES_PATHS.AMAZON_SHOP}
                      component={V2AmazonShop}
                    />
                    <Route
                      path={ROUTES_PATHS.APIS_AND_INTEGRATIONS}
                      component={V2APIsAndIntegrations}
                    />
                    <Route
                      path={ROUTES_PATHS.ENERGY_INTELLIGENCE}
                      component={V2EnergyIntelligence}
                    />
                    <Route
                      path={ROUTES_PATHS.HARDWARE}
                      component={V2Hardware}
                    />
                    <Route
                      path={ROUTES_PATHS.OFFER_TO_UTILITIES}
                      component={V2Utilities}
                    />
                    <Route
                      path={ROUTES_PATHS.REQUEST_A_DEMO}
                      component={V2RequestADemo}
                    />
                    {/* <Route
                      path={ROUTES_PATHS.VOLTABOT}
                      component={V2Voltabot}
                    />*/}
                  </Switch>
                )}
              />

              <Redirect
                exact
                from="/our-technology/voltacare"
                to="/our-technology"
              />
              <Redirect
                exact
                from="/our-technology/voltaware-sensors"
                to={ROUTES_PATHS.HARDWARE}
              />
              <Redirect
                exact
                from="/voltacare/terms-and-conditions"
                to="/our-technology"
              />
              <Redirect exact from="/team" to="/team/about-us" />

              <Route
                render={() => (
                  <div className="v1-layout">
                    <Switch>
                      <Route exact path="/old" component={Home} />
                      <Route path="/acceptable-use" component={AcceptableUse} />
                      <Route
                        exact
                        path="/amazon-shop-2"
                        component={AmazonShop2}
                      />
                      {/* <Route exact path="/deal" component={LandingDeal} />*/}

                      <Route
                        exact
                        path="/case-studies/cut-energy-bill-uk-case-study"
                        component={LandingCaseStudy}
                      />

                      <Route
                        exact
                        path="/our-technology"
                        component={OurTechnology}
                      />
                      <Route
                        exact
                        path="/our-technology/smart-meters-integration"
                        component={OurTechnologySmartMeters}
                      />
                      <Route
                        exact
                        path="/our-technology/continuous-learning"
                        component={OurTechnologyContinuousLearning}
                      />
                      <Route
                        path="/integrate-with-voltaware"
                        component={IntegrateWithVoltaware}
                      />
                      <Route exact path="/blog" component={Blog} />

                      {BlogPosts.map((post, index) =>
                        post.link ? (
                          <Route
                            component={BlogPost}
                            key={index}
                            path={post.link}
                          />
                        ) : (
                          ''
                        ),
                      )}
                      <Route
                        path="/blog/:slug"
                        render={() => <Redirect to="/blog" />}
                      />

                      <Route path="/team/about-us" component={AboutUs} />
                      <Route path="/team/work-with-us" component={Team} />
                      <Route path="/faq" component={Support} />
                      <Route path="/support" component={Support} />
                      <Route path="/privacy-policy" component={PrivacyPolicy} />
                      <Route
                        path="/terms-and-conditions"
                        component={ConsumerStandardTerms}
                      />
                      <Route path="/product-terms" component={ProductTerms} />
                      <Route path="/join-us" component={JoinUs} />
                      <Route path="/contact-us" component={ContactUs} />
                      <Route
                        path="/order-cancellation"
                        component={Cancellation}
                      />
                      <Redirect to="/" />
                    </Switch>
                  </div>
                )}
              />

              <Redirect to="/" />
            </Switch>
          </V2Layout>
        </Layout>
      )}
    />
  </Switch>
);

export default routes;
